import { render } from "./Yaml.vue?vue&type=template&id=e73074f0"
import script from "./Yaml.vue?vue&type=script&lang=js"
export * from "./Yaml.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__